export const GET_ASSESSMENT_LIST = '/building_assessment/get_assessment_list';
export const SHOW_ASSESSMENT_DATA = '/building_assessment/show_assessment_data';
export const CREATE_ASSESSMENT_DATA = '/building_assessment/create_assessment_data';
export const UPDATE_ASSESSMENT_DATA = '/building_assessment/update_assessment_data';
export const DELETE_ASSESSMENT_DATA = '/building_assessment/delete_assessment_data';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';

export const GET_RECORD_OF_SUP_ASSESSMENT = '/building/get_record_of_sup_assessment';
export const GET_SINGLE_RECORD_OF_SUP_ASSESSMENT = '/building/get_single_record_of_sup_assessment';
export const CREATE_RECORD_OF_SUP_ASSESSMENT = '/building/create_record_of_sup_assessment';
export const UPDATE_RECORD_OF_SUP_ASSESSMENT = '/building/update_record_of_sup_assessment';
export const REMOVE_RECORD_OF_SUP_ASSESSMENT = '/building/remove_record_of_sup_assessment';

export const GET_HISTORY_RECORD_OF_SUP_ASSESSMENT = '/building/get_history_record_of_sup_assessment';

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  actual_use: '',
};

export const SUP_ASSESSMENT_FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
}